/**
 * Inline alert / feedback banner family — extracted out of `overlayStyles.js`
 * to keep that module under the 500-line cap (same pattern as
 * `./confirmDialogStyles`: a self-contained family gets its own file rather
 * than growing the shared one). Import directly from here; `overlayStyles.js`
 * deliberately does NOT re-export these, so the two modules stay acyclic.
 */

import { foundation as f } from './tokens';

const { color, spacePx, fontSize } = f;

/** Tone -> leading icon colour for a calm banner. */
export const bannerToneColor = {
  info: color.semantic.info,
  success: color.semantic.successIcon,
  warning: color.semantic.warning,
  error: color.semantic.danger,
};

/** "×" dismiss button for feedback banners */
export const bannerDismissButton = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: `0 ${spacePx[1]}`,
  fontSize: fontSize.lg,
  lineHeight: 1,
  color: 'inherit',
  opacity: 0.7,
  flexShrink: 0,
};
